"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initiateChat = initiateChat;

var _scriptHelper = require("@eig-builder/core-utils/helpers/script-helper");

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _cookieHelper = require("@eig-builder/core-utils/helpers/cookie-helper");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

function initiateChat() {
  window.BuilderAssistance = window.BuilderAssistance || function () {
    ;
    (window.BuilderAssistance.q = window.BuilderAssistance.q || []).push(arguments);
  }; // if either of the genesys cookies aren't present, hide the chat widget


  var params = {
    hideOnInit: !(0, _cookieHelper.getCookie)('genesys-chat-session-data') || !(0, _cookieHelper.getCookie)('genesys-chat-session')
  };

  if (process.env.isProd) {
    var siteName = (0, _runtimeConfigHelper.getRuntimeConfig)().version === 2 ? _urlHelper.siteNames.APP : _urlHelper.siteNames.CP_MY;
    (0, _scriptHelper.IncludeJavaScript)((0, _urlHelper.getUrl)(siteName, '/kb/sdk.js'), 'chat-sdk', window.BuilderAssistance('init', params));
  } else {
    (0, _scriptHelper.IncludeJavaScript)('http://localhost:4002/sdk.js', 'chat-sdk', window.BuilderAssistance('init', params));
  }
}